import NewRecord from './NewRecord';

export default NewRecord;
